"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M3 5h10a1 1 0 010 2H3a1 1 0 110-2zm0 4h10a1 1 0 010 2H3a1 1 0 010-2z"];
//# sourceMappingURL=equals.js.map